import { List, ListItemText, ListItem, ListItemIcon } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

function InfoItem({ content }) {
  return (
    <ListItem>
      <ListItemIcon>
        <DoneIcon />
      </ListItemIcon>
      <ListItemText>{content}</ListItemText>
    </ListItem>
  );
}

function WarningItem({ content }) {
  return (
    <ListItem>
      <ListItemIcon>
        <PriorityHighIcon />
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ sx: { fontWeight: "bold" } }}>
        {content}
      </ListItemText>
    </ListItem>
  );
}

export const FrontCardDialogBody = (
  <List>
    <InfoItem content="Ảnh CMT phải là ảnh gốc, không scan và photocopy" />
    <InfoItem content="Hãy cho phép web truy cập vào thiết bị camera của bạn" />
    <InfoItem content="Nếu bạn dùng tablet, có thể xoay dọc thiết bị nếu camera bị khuất" />
    <InfoItem content="Khi chụp, để mặt trước CMT bao trọn trong viền xanh trên màn hình" />
    <InfoItem content="Chụp ảnh rõ ràng, đủ góc cạnh, không bị lóa sáng, không che nội dung CMT" />
    <InfoItem content="Kết quả OCR sẽ được hiển thị ở ô 'Thông tin CMT' sau khi ảnh được xử lý" />
    <WarningItem content="Người chụp ảnh chịu hoàn toàn trách nhiệm trước pháp luật về thông tin đã cung cấp" />
  </List>
);

export const BackCardDialogBody = (
  <List>
    <InfoItem content="Ảnh CMT phải là ảnh gốc, không scan và photocopy" />
    <InfoItem content="Khi chụp, để mặt sau CMT bao trọn trong viền xanh trên màn hình" />
    <InfoItem content="Chụp ảnh rõ ràng, đủ góc cạnh, không bị lóa sáng, không che nội dung CMT" />
    <InfoItem content="Kết quả OCR sẽ được hiển thị ở ô 'Thông tin CMT' sau khi ảnh được xử lý" />
    <WarningItem content="Người chụp ảnh chịu hoàn toàn trách nhiệm trước pháp luật về thông tin đã cung cấp" />
  </List>
);

export const FaceDialogBody = (
  <List>
    <InfoItem content="Để camera bao trọn khuôn mặt bạn và không để mặt người khác cùng xuất hiện trong camera" />
    <InfoItem content="Để xác thực, hãy làm theo chỉ dẫn ở phía dưới màn hình máy ảnh" />
    <InfoItem content="Số giây còn lại để bạn thực hiện chỉ dẫn sẽ được hiển thị bên góc trái, trên cùng" />
    <InfoItem content="Sẽ có âm thanh được phát ra để thông báo bạn đã thực hiện thành công một bước xác thực" />
    <WarningItem content="Bạn sẽ phải xác thực lại từ đầu nếu không thực hiện theo chỉ dẫn trong thời gian cho phép, hoặc rời mặt bạn khỏi màn hình" />
    <InfoItem content="Sau khi xử lí xong, thông tin so sánh kuôn mặt sẽ được hiển thị ở ô 'Kết quả eKYC'" />
  </List>
);
